import {NeoModal} from "@/components/@modal/neo.modal";
import {useState} from "react";

export const NeoRatingAttachments: React.FC<any> = ({data, uid}) => {
  const ratingAttachments = data[uid] || null;

  const [modalOpen, setModalOpen] = useState(false);

  const imageSrc = ratingAttachments;
  const lowerUrl = imageSrc?.toLowerCase() || "";

  const fileType = lowerUrl.includes(".pdf")
    ? "pdf"
    : lowerUrl.includes(".png") ||
        lowerUrl.includes(".jpg") ||
        lowerUrl.includes(".jpeg")
      ? "image"
      : "unknown";

  return (
    <>
      <div className="flex items-center">
        {imageSrc ? (
          <button
            type="button"
            onClick={() => setModalOpen(true)}
            className="rounded hover:bg-yellow-50"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              className="text-yellow-500"
            >
              <path d="M21.44 11.05 12 20.5a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66L9.17 18.17a2 2 0 1 1-2.83-2.83l8.49-8.49" />
            </svg>
          </button>
        ) : (
          <span>N/A</span>
        )}
      </div>
      <NeoModal
        actionType="attachmentPreviewTripRating"
        onOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        hasActions={false}
        data={{imageSrc, fileType}}
      />
    </>
  );
};
